/* eslint-disable */
import { sendEvent } from '@blocket/tracking'

const trackedPlacements = ['panorama_device_2', 'vi_image_integration']

const trackImpression = (placementId, creativeId, variant) => {
  const _params = {
    placementId,
    creativeId,
    variant,
  }

  return {
    setCreative: (cid) => {
      _params.creativeId = cid
    },
    setVariant: (type) => {
      _params.variant = type
    },
    //TODO: generalize and move this into blocket/tracking once zebra stream has set their standard
    send: (impressionType) => {
      if (!trackedPlacements.includes(_params.placementId)) return

      sendEvent({
        eventCategory: 'internal-promotions',
        evenLabel: `appnexus ${_params.placementId}`,
        eventAction: 'internal-promotion-action',
        eventType: 'View',
        event: 'event',
        objectType: 'UIElement',
        objectId: 'internal-promotions',
        ecommerce: {
          promoView: {
            promotions: [
              {
                id: `appnexus-${_params.placementId}-${_params.variant}-${impressionType}`,
                name: `appnexus-${_params.placementId}-${_params.variant}-${impressionType}`,
                creative: _params.creativeId,
                position: _params.placementId,
              },
            ],
          },
        },
      })

      // clear the promotions as there is indication they may be sticky between unique view events
      window.dataLayer.push({ ecommerce: { promoView: { promotions: [] } } })
    },
    isTracked: () => trackedPlacements.includes(_params.placementId),
  }
}
export default trackImpression
